module.exports = __webpack_public_path__ + "img/11.15834f82.png";